import axios from "axios";
import Crypto from "@/helper/crypto";
const defaultProfilePic = "/images/logo/default-profile-pic.png";

const store = {
  state: {
    customer: null,
    /*selectedCountry: localStorage.getItem("selectedCountry")
      ? JSON.parse(localStorage.getItem("selectedCountry"))
      : null,
    selectedCountryCode: localStorage.getItem("countryCode")
      ? localStorage.getItem("countryCode")
      : null,*/
  },
  getters: {
    getCustomer(state) {
      return state.customer;
    },
    /*getCustomerCountry(state) {
      return state.selectedCountry;
    },*/
  },
  mutations: {
    DEFINE_CUSTOMER(state, payload) {
      state.customer = {
        id: payload.id,
        name: payload.name,
        email: payload.email,
        phone_number: payload.phone_number,
        //country: payload.country,
        profile_pic: payload.profile_pic || defaultProfilePic,
        company_name: payload.company_name,
        status: payload.status,
      };

      /*if (!state.selectedCountry) {
        state.selectedCountry = payload.country;
        state.selectedCountryCode = payload.country.code;
        localStorage.setItem("selectedCountry", JSON.stringify(payload.country));
        localStorage.setItem("countryCode", payload.country.code);
      }*/
    },
    /*CHANGE_CUSTOMER_COUNTRY(state, country) {
      state.selectedCountry = country;
      state.selectedCountryCode = country.code;
      localStorage.setItem("selectedCountry", JSON.stringify(country));
      localStorage.setItem("countryCode", country.code);
    },*/
  },
  actions: {
    retrieveCustomerInfo({ commit, state, rootState }) {
      return axios
        .get(this._vm.$endpoints.customer_profile)
        .then((res) => {
          let response = res.data.data;
          commit("DEFINE_CUSTOMER", response);
        })
        .catch((err) => {
          throw err;
        });
    },
    /*changeCustomerCountry({ commit, state }, country) {
      commit("CHANGE_CUSTOMER_COUNTRY", country);
    },*/
  },
};

export default store;
